export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11331.0cbc9962.jpg";